/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

const buildCannedResponsePayload = ({
  short_code: shortCode,
  content,
  attachment,
  remove_attachment: removeAttachment,
}) => {
  if (!attachment && !removeAttachment) {
    return { short_code: shortCode, content };
  }

  const payload = new FormData();
  payload.append('canned_response[short_code]', shortCode);
  payload.append('canned_response[content]', content || '');
  if (attachment) payload.append('canned_response[attachment]', attachment);
  if (removeAttachment)
    payload.append('canned_response[remove_attachment]', true);
  return payload;
};

class CannedResponse extends CacheEnabledApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'canned_response';
  }

  // The index endpoint returns a bare array instead of a payload wrapper
  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: dataToParse };
  }

  create(data) {
    return axios.post(this.url, buildCannedResponsePayload(data));
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, buildCannedResponsePayload(data));
  }
}

export default new CannedResponse();
